import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
export function phonePrefixFilter(search: any, option: any) {
  const [item] = phonePrefixOptions.filter((o: any) => o.value === option.value);
  return item.label.indexOf(search) !== -1;
}
